import React,{useRef, useState} from 'react'
import { Form , Button , Card, Alert } from 'react-bootstrap'
import { Container } from 'react-bootstrap'
import { useAuth } from 'contexts/authContext'
import { Link , useHistory } from 'react-router-dom'
import Background from 'assets/img/ab.jpg';
// import Background1 from 'assets/img/b.jpg';

export default function Login() {
  const emailRef = useRef()
  const passwordRef = useRef()
  const {login } = useAuth()
  const [error,setError] = useState('')
  const [loading ,setLoading] = useState(false)
  const history = useHistory()

async function handleSubmit(e){
    e.preventDefault()
  
    try{

      setError('')
      setLoading(true)
      await login(emailRef.current.value, passwordRef.current.value)
      history.push("/HomeS")

    }catch{
       setError('failed to login')
    }
    setLoading(false)
}



var sectionStyle = {
  // width: "100%",
  // height: "100%",
  backgroundSize: 'cover', 
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundImage: `url(${Background } )` 
};

// var sectionStyle1 = {
//   width: "100%",
//   height: "100%",
//   backgroundImage: `url(${Background1})`
// };


    return (
        <>

  <section style={ sectionStyle }>
            
        <container
        className = "d-flex align-items-center justify-content-center"
        style = {{minHeight: "100vh"}}
        >
            <div className="w-100" style = {{maxWidth:'420px'} }>
  
          <Card>
            
          <Card.Body>
          <h3 className="text-center mb-4">Login</h3>
         
          {error && <Alert variant="danger">{error}</Alert>}
          
          <Form  onSubmit={handleSubmit} >
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" ref={emailRef} required />
            </Form.Group>
            <Form.Group id="password">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" ref={passwordRef} required />
            </Form.Group>
            <br></br>
            <Button disabled={loading} className="w-100" type="submit">
              Login
            </Button>
            <br></br>
            <br></br>
            
            <div className="w-100 text-center mt-3">
            <Link to = "/forgot-password">Forgot Password?</Link>
          </div>

          </Form>
         
      <div className="w-100 text-center mt-2">
      Need an account? <Link to="/signup">Sign Up</Link>
      </div>

      
      </Card.Body>
      <br></br>
      
      </Card>

      </div>      
      </container>

      </section> 
        </>
    )
}
